import { PageLoading } from 'module/ui/components/atoms/loading';
import { useSalesForceAutomationsDetails } from 'queries/salesforce';
import { useParams } from 'react-router-dom';
import { AutomationProvider } from 'components/organisms/integrations/salesforce/create/automation-context';
import { EditAutomationLayout } from 'components/organisms/integrations/salesforce/edit/edit-automation-layout';

function SalesforceEditPageContent() {
  const { automationId } = useParams<{ automationId: string }>();
  const { data, isLoading, isError } = useSalesForceAutomationsDetails(
    Number(automationId),
    {
      enabled: !!automationId,
    },
  );

  if (isLoading) {
    return <PageLoading />;
  }

  if (isError || !data) {
    return <div>Error loading automation</div>;
  }

  return <EditAutomationLayout initialData={data} />;
}

function SalesforceEditPage() {
  return (
    <AutomationProvider>
      <SalesforceEditPageContent />
    </AutomationProvider>
  );
}

export { SalesforceEditPage };
